const version = {"builtAt":"2026-10-14T11:53:41.129Z","branch":"staging","commit":"f9a4a26"};

module.exports = version;
